'use-client';
import classNames from 'clsx';
import * as React from 'react';
import { getDataAttributes } from '@wix/editor-elements-common-utils';

import type { ISkypeCallButtonProps } from '../SkypeCallButton.types';
import style from './style/SkypeCallButton.scss';

const SkypeCallButton: React.FC<ISkypeCallButtonProps> = props => {
  const { id, className, href, ariaLabel, onMouseEnter, onMouseLeave } = props;

  const linkProps = href
    ? {
        href,
        'aria-label': ariaLabel,
        title: ariaLabel,
      }
    : {};

  return (
    <div
      id={id}
      {...getDataAttributes(props)}
      className={classNames(className, style.container)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <a className={style.link} {...linkProps}>
        <div className={style.buttonImage} />
      </a>
    </div>
  );
};

export default SkypeCallButton;
